var map = {
	"./ar": 58896,
	"./ar.ts": 58896,
	"./bn": 22628,
	"./bn.ts": 22628,
	"./en": 87333,
	"./en.ts": 87333,
	"./fa": 76500,
	"./fa.ts": 76500,
	"./fr": 92565,
	"./fr.ts": 92565,
	"./id": 16636,
	"./id.ts": 16636,
	"./it": 16240,
	"./it.ts": 16240,
	"./ms": 27386,
	"./ms.ts": 27386,
	"./nl": 85343,
	"./nl.ts": 85343,
	"./pt": 10778,
	"./pt.ts": 10778,
	"./ru": 16456,
	"./ru.ts": 16456,
	"./sq": 89326,
	"./sq.ts": 89326,
	"./th": 23296,
	"./th.ts": 23296,
	"./tr": 2244,
	"./tr.ts": 2244,
	"./ur": 21730,
	"./ur.ts": 21730,
	"./zh": 13732,
	"./zh.ts": 13732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70301;